import { ParameterData } from '@/features/ocr/types/ParameterData';
import { BASE_URL } from '@/utils/Constants';
import { useAuth } from '@/utils/stores/useAuthStore';
import { useQuery } from '@tanstack/react-query';

export const getSingleParam = async (
  paramId: string,
  token: string,
  userId: string,
) => {
  const response = await fetch(
    `${BASE_URL}/api/anamnestic-data/data-points/user/${userId}/${paramId}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  );
  if (!response.ok) {
    throw new Error('Failed to fetch parameter');
  }
  return response.json() as Promise<ParameterData[]>;
};

export const useGetSingleParam = (paramId: string) => {
  const { idToken, userId } = useAuth();
  return useQuery({
    queryKey: ['singleParam', paramId, userId, idToken],
    queryFn: () => getSingleParam(paramId, idToken!, userId!),
    enabled: !!paramId && !!userId && !!idToken,
  });
};
